import React from 'react';

const AltContext = React.createContext(false);
const ShiftContext = React.createContext(false);
const CtrlContext = React.createContext(false);

export function ModifierContext({ children }) {
  const [altKey, setAlt] = React.useState(false);
  const [shiftKey, setShift] = React.useState(false);
  const [ctrlKey, setCtrl] = React.useState(false);
  const altRef = React.useRef(false);
  const shiftRef = React.useRef(false);
  const ctrlRef = React.useRef(false);

  React.useEffect(() => {
    function listener(e) {
      if (e.key === "Alt") {
        e.preventDefault();
      }
      if (e.altKey !== altRef.current) {
        altRef.current = e.altKey;
        setAlt(e.altKey);
      }
      if (e.shiftKey !== shiftRef.current) {
        shiftRef.current = e.shiftKey;
        setShift(e.shiftKey);
      }
      if (e.ctrlKey !== ctrlRef.current) {
        ctrlRef.current = e.ctrlKey;
        setCtrl(e.ctrlKey);
      }
    }
    document.addEventListener("keydown", listener, true);
    document.addEventListener("keyup", listener, true);
    return () => {
      document.removeEventListener("keydown", listener, true);
      document.removeEventListener("keyup", listener, true);
    };
  }, []);

  return (
    <AltContext.Provider value={altKey}>
      <ShiftContext.Provider value={shiftKey}>
        <CtrlContext.Provider value={ctrlKey}>
          {children}
        </CtrlContext.Provider>
      </ShiftContext.Provider>
    </AltContext.Provider>
  );
}

export function useAlt() {
  return React.useContext(AltContext);
}
export function useShift() {
  return React.useContext(ShiftContext);
}
export function useCtrl() {
  return React.useContext(CtrlContext);
}
